import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface NavigationGuard {
  active: boolean
  title: string
  message: string
}

interface AppState {
  theme: 'light' | 'dark' | 'system'
  setTheme: (theme: 'light' | 'dark' | 'system') => void

  isLoading: boolean
  setLoading: (loading: boolean) => void

  unreadNotifications: number
  setUnreadNotifications: (count: number) => void

  navigationGuard: NavigationGuard
  setNavigationGuard: (guard: NavigationGuard) => void

  /**
   * 节点是否还有在售档位。null = 本机从未探测过。
   * 底部 tab 靠它决定第二个 tab 叫「节点」还是「短剧」（三档全下架后节点页整页是短剧出海预告）。
   * 持久化到本地：否则每次冷启动都会先画「节点」再跳成「短剧」，闪一下。
   */
  nodeOnSale: boolean | null
  setNodeOnSale: (onSale: boolean) => void
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => set({ theme }),

      isLoading: false,
      setLoading: (loading) => set({ isLoading: loading }),

      unreadNotifications: 0,
      setUnreadNotifications: (count) => set({ unreadNotifications: count }),

      navigationGuard: { active: false, title: '', message: '' },
      setNavigationGuard: (guard) => set({ navigationGuard: guard }),

      nodeOnSale: null,
      setNodeOnSale: (onSale) => set({ nodeOnSale: onSale }),
    }),
    {
      name: 'app-store',
      partialize: (state) => ({
        theme: state.theme,
        nodeOnSale: state.nodeOnSale,
      }),
    }
  )
)
